import { render, staticRenderFns } from "./General_Comp.vue?vue&type=template&id=a968d552&scoped=true&"
import script from "./General_Comp.vue?vue&type=script&lang=js&"
export * from "./General_Comp.vue?vue&type=script&lang=js&"
import style0 from "./General_Comp.vue?vue&type=style&index=0&id=a968d552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a968d552",
  null
  
)

export default component.exports